import { NavGroup } from '@/components/layout/nav-group'
import { NavUser } from '@/components/layout/nav-user'
import { SidebarData } from '@/components/layout/types'
import {
	Sidebar,
	SidebarContent,
	SidebarFooter,
	SidebarHeader,
	SidebarRail,
} from '@/components/ui/sidebar'
import { useAuthStore } from '@/stores/authStore'
import type { AuthUser } from '@/stores/types'
import { sidebarData as initialSidebarData } from './data/sidebar-data'

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
	const user = useAuthStore((state) => state.auth.user)
	const sidebarDataUser: AuthUser = {
		email: user?.email,
		username: user?.username,
		avatar: user?.avatar,
		walletAddress: user.walletAddress,
	}

	const sidebarData: SidebarData = {
		...initialSidebarData,
		user,
	}

	return (
		<Sidebar collapsible="icon" variant="floating" {...props}>
			<SidebarHeader />
			<SidebarContent>
				{sidebarData.navGroups.map((props) => (
					<NavGroup key={props.title} {...props} />
				))}
			</SidebarContent>
			<SidebarFooter>
				<NavUser user={sidebarDataUser} />
			</SidebarFooter>
			<SidebarRail />
		</Sidebar>
	)
}
